import { zeroPadding } from './zeroPadding';

/**
 * Получить выражение, описывающее множественное число, состоящее из числа и слова в правильной форме
 *
 * @param count - Числовая часть.
 * @param words - Словесная часть.
 * @param options - Опции.
 * @returns Строка с числом и словом в правильной форме.
 */
export const pluralize = (
  count: number,
  words: string[],
  options: { withZeroPad?: boolean } = {},
) => {
  const { withZeroPad } = options;
  const cases = [2, 0, 1, 1, 1, 2];
  const formattedCount = Math.abs(count);

  const resultNumber = withZeroPad ? zeroPadding(count) : count;

  if (formattedCount - Math.floor(formattedCount)) {
    return `${resultNumber} ${words[1]}`;
  }

  return `${resultNumber} ${
    words[
      formattedCount % 100 > 4 && formattedCount % 100 < 20
        ? 2
        : cases[Math.min(formattedCount % 10, 5)]
    ]
  }`;
};
